import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface PayoutListProps {
  rows: any[];
  isLoading: boolean;
  count: number;
  page: number;
  onPageChange: (event: any, newPage: number) => void;
  onRefresh?: () => void;
}

function PayoutList({
  rows,
  isLoading,
  count,
  page,
  onPageChange,
  onRefresh,
}: PayoutListProps) {
  const hidden: string[] = [];
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "freelancerId",
      headerName: "Freelancer Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-freelancer/detail/${row?.freelancerId?._id}`)
            }
          >
            <figure>
              <img
                src={
                  row?.freelancerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${row?.freelancerId?.firstName} ${row?.freelancerId?.lastName}`}</b>
              <span>{row?.freelancerId?.email || "-"}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "amount",
      headerName: "Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_primary">
            <strong>AED {Number(row?.amount).toFixed(2)}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "createdAt",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div>
            <p>{moment(row?.createdAt).format("DD/MM/YYYY hh:mm:ss A")}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Button
            className="btn sm btn_primary"
            // onClick={() => handleOpenConfirmDialog(row)}
          >
            Pay
          </Button>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 120,
    //   field: "status",
    //   headerName: "Status",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <span
    //         className={`btn_text ${
    //           row?.status === 1 ? "c_success" : "c_warning"
    //         }`}
    //       >
    //         {row?.status === 1 ? "Paid" : "Pending"}
    //       </span>
    //     );
    //   },
    // },
  ];

  return (
    <div className="sorting_table">
      <TableComponent
        columns={columns?.filter((item) => !hidden.includes(item.field))}
        rows={rows}
        loading={isLoading}
        count={count}
        page={page}
        onPageChange={onPageChange}
      />
    </div>
  );
}

export default PayoutList;
